import React from 'react';

import cn from 'classnames';

import { useGetAdminFormQuery } from '@entities/adminConversationUserHistory';
import { UserHistoryRow } from '@entities/adminConversationUserHistory/ui/UserHistoryRow';
import { UserHistoryTableHead } from '@entities/adminConversationUserHistory/ui/UserHistoryTableHead';
import { useNuqsQueryState } from '@shared/hooks';
import { Flex } from '@shared/ui';

import cls from './AdminConversationUserHistory.module.css';
import { useAdminConversationUserHistory } from '../lib/hooks/useAdminConversationUserHistory';

interface AdminConversationUserHistoryProps {
    classes?: string;
}

export const AdminConversationUserHistory = ({ classes }: AdminConversationUserHistoryProps) => {
    useAdminConversationUserHistory();

    const { state } = useNuqsQueryState('formId');
    const { state: formType } = useNuqsQueryState('type');

    const { data } = useGetAdminFormQuery(+state);

    return (
        <div className={cn(cls.AdminConversationUserHistory, [classes])}>
            <UserHistoryTableHead />
            <Flex direction="column" fullWidth>
                {data?.map((row, index) => (
                    <UserHistoryRow formType={formType} row={row} key={index} />
                ))}
            </Flex>
        </div>
    );
};
